import { useState } from "react";

import {
    firstnameValidator,
    lastnameValidator,
    companyValidator,
  emailValidator,
  confirmemailValidator,
  phoneValidator,
  zipcodeValidator,
  commentValidator,
  cityValidator,
  stateValidator
} from "../validators.js";

const touchErrors = errors => {
  return Object.entries(errors).reduce((acc, [field, fieldError]) => {
    acc[field] = {
      ...fieldError,
      dirty: true,
    };
    return acc;
  }, {});
};

export const useLoginFormValidator = form => {
  const [errors, setErrors] = useState({
    firstname: {
      dirty: false,
      error: false,
      message: "",
    },
    lastname:  {
      dirty: false,
      error: false,
      message: "",
    },
    company : {
      dirty: false,
      error: false,
      message: "",
    },
    email: {
      dirty: false,
      error: false,
      message: "",
    },
    confirmemail :{
        dirty: false,
        error: false,
        message: "",
      },
    phone: {
      dirty: false,
      error: false,
      message: "",
    },
    locationCity: {
      dirty: false,
      error: false,
      message: "",
    },
    locationST: {
      dirty: false,
      error: false,
      message: "",
    },
    locationZip: {
      dirty: false,
      error: false,
      message: "",
    },
    comment: {
      dirty: false,
      error: false,
      message: "",
    }
    
  });

  const validateForm = ({ form, field, errors, forceTouchErrors = false }) => {
    let isValid = true;

    // Create a deep copy of the errors
    let nextErrors = JSON.parse(JSON.stringify(errors));

    // Force validate all the fields
    if (forceTouchErrors) {
      nextErrors = touchErrors(errors);
    }

    const { email,firstname,lastname,company,confirmemail ,phone, locationZip, locationCity, locationST, comment} = form;

    if (nextErrors.firstname.dirty && (field ? field === "firstname" : true)) {
        const firstnameMessage = firstnameValidator(firstname, form);
        nextErrors.firstname.error = !!firstnameMessage;
        nextErrors.firstname.message = firstnameMessage;
        if (!!firstnameMessage) isValid = false;
      }
      if (nextErrors.lastname.dirty && (field ? field === "lastname" : true)) {
        const lastnameMessage = lastnameValidator(lastname, form);
        nextErrors.lastname.error = !!lastnameMessage;
        nextErrors.lastname.message = lastnameMessage;
        if (!!lastnameMessage) isValid = false;
      }
      if (nextErrors.company.dirty && (field ? field === "company" : true)) {
        const companyMessage = companyValidator(company, form);
        nextErrors.company.error = !!companyMessage;
        nextErrors.company.message = companyMessage;
        if (!!companyMessage) isValid = false;
      }

    if (nextErrors.email.dirty && (field ? field === "email" : true)) {
      nextErrors.confirmemail.error = nextErrors.confirmemail.message === "Incorrect email format" ? true : false;
      nextErrors.confirmemail.message = nextErrors.confirmemail.message === "Incorrect email format" ? nextErrors.confirmemail.message : "";

      const emailMessage = emailValidator(email, form);
      nextErrors.email.error = !!emailMessage;
      nextErrors.email.message = emailMessage;
      if (!!emailMessage) isValid = false;
    }

    if (nextErrors.confirmemail.dirty && (field ? field === "confirmemail" : true)) {
        nextErrors.email.error = nextErrors.email.message === "Incorrect email format" ? true : false;
        nextErrors.email.message = nextErrors.email.message === "Incorrect email format" ? nextErrors.email.message : "";
        
        const confirmemailMessage = confirmemailValidator(confirmemail, form);
        nextErrors.confirmemail.error = !!confirmemailMessage;
        nextErrors.confirmemail.message = confirmemailMessage;
        if (!!confirmemailMessage) isValid = false;
    }
    
      if (nextErrors.phone.dirty && (field ? field === "phone" : true)) {
        const phoneMessage = phoneValidator(phone, form);
        nextErrors.phone.error = !!phoneMessage;
        nextErrors.phone.message = phoneMessage;
        if (!!phoneMessage) isValid = false;
      }

      if (nextErrors.locationZip.dirty && (field ? field === "locationZip" : true)) {
        const locationZipMessage = zipcodeValidator(locationZip, form);
        nextErrors.locationZip.error = !!locationZipMessage;
        nextErrors.locationZip.message = locationZipMessage;
        if (!!locationZipMessage) isValid = false;
      }

      if (nextErrors.locationCity.dirty && (field ? field === "locationCity" : true)) {
        const locationCityMessage = cityValidator(locationCity, form);
        nextErrors.locationCity.error = !!locationCityMessage;
        nextErrors.locationCity.message = locationCityMessage;
        if (!!locationCityMessage) isValid = false;
      }

      if (nextErrors.locationST.dirty && (field ? field === "locationST" : true)) {
        const locationSTMessage = stateValidator(locationST, form);
        nextErrors.locationST.error = !!locationSTMessage;
        nextErrors.locationST.message = locationSTMessage;
        if (!!locationSTMessage) isValid = false;
      }
      
      if (nextErrors.comment.dirty && (field ? field === "comment" : true)) {
        const commentMessage = commentValidator(comment, form);
        nextErrors.comment.error = !!commentMessage;
        nextErrors.comment.message = commentMessage;
        if (!!commentMessage) isValid = false;
      }
    setErrors(nextErrors);

    return {
      isValid,
      errors: nextErrors,
    };
  };

  const onBlurField = e => {
    const field = e.target.name;
    const fieldError = errors[field];
    if (fieldError.dirty) return;

    const updatedErrors = {
      ...errors,
      [field]: {
        ...errors[field],
        dirty: true,
      },
    };

    validateForm({ form, field, errors: updatedErrors });
  };

  return {
    validateForm,
    onBlurField,
    errors,
  };
};
